// savedPlaces — favoris "Enregistrés" AYA Search (localStorage) (v5.7.0).
const KEY = "aya_saved_places_v1";

export function listSaved() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

function _write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* stockage plein */ }
  try { window.dispatchEvent(new Event("aya-saved-changed")); } catch { /* SSR */ }
}

export function isSaved(id) {
  return listSaved().some((s) => s.id === id);
}

/** Ajoute ou retire une fiche. Retourne true si ajoutée, false si retirée. */
export function toggleSaved(entry) {
  const list = listSaved();
  const i = list.findIndex((s) => s.id === entry.id);
  if (i >= 0) { list.splice(i, 1); _write(list); return false; }
  list.unshift({ ...entry, saved_at: new Date().toISOString() });
  _write(list.slice(0, 200));
  return true;
}

export function removeSaved(id) {
  _write(listSaved().filter((s) => s.id !== id));
}
